<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
        <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item
            ><router-link to="/attendance/">Attendance</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
      <b-col md="12">
        <div class="m-auto justify-content-center text-center h-75">
        <h1 style="font-size: 86px; opacity: 0.3;" class="text-center text-uppercase font-weight-bolder text-info text-bold">No report today</h1>
        <h4 style="opacity: 0.2;">Haven't filled out today's attendance :(</h4>
        </div>
      </b-col>
    </b-row>
     <b-row class="mt-5 mb-3">
      <b-col>
        <b-row>
          <b-col md="2">
            <label for="" class="labels">Name :</label>
          </b-col>
          <b-col class="d-flex">
            <p style="margin-right: 8px;"> {{userProfile !== undefined ? userProfile : '-'}}</p>
          </b-col>
        </b-row>
        
        <b-row class="mt-3">
          <b-col md="12">
            <div class="table-responsive">
              <table class="table table-hovered table-striped">
                <thead>
                  <tr>
                    <th scope="col" width="100">Date</th>
                    <th scope="col" width="100">Out Station</th>
                    <th scope="col" width="100">Clock In</th>
                    <th scope="col" width="100">Start Break</th>
                    <th scope="col" width="100">End Break</th>
                    <th scope="col" width="100">Clock Out</th>
                    <th scope="col" width="100">Total Minutes Late</th>
                    <th scope="col" width="100">Total Hour</th>
                    <!-- <th scope="col" width="100">Overtime</th> -->
                    <th scope="col" width="100">Detail</th>
                  </tr>
                </thead>
                <tbody v-if="dataUser.length > 0">
                  <tr v-for="(item, index) in dataUser" :key="index">
                    <td v-text="getDate(item.clockInTime)"></td>
                    <td>
                      <div v-if="item.isOutstation === true">
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </div>
                      <div v-else>
                        <p>-</p>
                      </div>
                    </td>
                    <td
                      v-text="
                        item.clockInTime !== null
                          ? new Date(item.clockInTime).toLocaleTimeString().replace('.', '.')
                          : '-'
                      "
                    ></td>

                    <td
                      v-text="
                        item.breakInTime !== null
                          ? new Date(item.breakInTime).toLocaleTimeString().replace('.', '.')
                          : '-'
                      "
                    ></td>
                    <td
                      v-text="
                        item.breakOutTime !== null
                          ? new Date(item.breakOutTime).toLocaleTimeString().replace('.', '.')
                          : '-'
                      "
                    ></td>
                    <td
                      v-text="
                        item.clockOutTime !== null
                          ? new Date(item.clockOutTime).toLocaleTimeString().replace('.', '.')
                          : '-'
                      "
                    ></td>
                    <td>{{ item.totalMinutesLate !==null && item.totalMinutesLate !==0 ? item.totalMinutesLate : '-' }}</td>
                    <td>{{ item.clockHour }}</td>
                    <td>
                      <a
                        v-if="canShowRoutePath"
                        v-b-tooltip.hover.left
                        title="Details"
                        class="btn-op icon-info mr-1"
                        :href="'/#/attendance' + '/' + item.uuid + '/' + 'history'"
                      ></a>
                      <a
                        v-else
                        v-b-tooltip.hover.left
                        title="Details"
                        class="btn-op icon-info mr-1"
                        :href="'#' + $route.path + '/' + item.uuid"
                      ></a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td></td>
                    <td></td>
                    <td><i>no data found </i></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>


          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-button class="mt-3 mb-5" @click="goBack" variant="secondary"
      ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
    >
    </b-card>
    </div>
</template>
<script>
export default {
  data(){
    return {
      apiUrl:{
        attendance: window.AppConfig.apiUrl + 'attendance'
      },
      dataUser: [],
      canShowRoutePath: {
        type: String,
        required: false,
        default: '',
      },
        userProfile: ''
      
      
    }
  },
  mounted(){
    this.getHistories()
  },
  methods: {
    getHistories(){
      this.$http.get(this.apiUrl.attendance + '?user_uuid=' + this.$route.params.uuid).then(resp=>{
        this.dataUser = []
        this.dataUser = resp.data._embedded.attendance
        this.userProfile = resp.data._embedded.attendance[0].userProfile
        console.log('history', this.model.userProfile );
      })
    },
     getClockTime(value) {
      if (value !== null) {
        return this.$moment(value).format('HH:mm');
      } else {
        return '-';
      }
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('H:mm DD MMMM YYYY');
      } else {
        return '-';
      }
    },

    getDate(value) {
      if (value !== null) {
        return this.$moment(value).format('DD-MM-YYYY');
      } else {
        return '-';
      }
    },

    goBack() {
      window.goBack(this);
    },
  }
}
</script>

<style scoped>
.fa-check{
  color:#fff;
  font-size: 22px;
  background-color: rgb(5, 151, 5);
  width: 36px;
  border-radius: 6px;
  text-align: center;
}
</style>